import { motion } from "framer-motion";

export const SectionHeader = ({ eyebrow, title, intro, align = "left" }) => {
    return (
        <div
            className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
        >
            {eyebrow && (
                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                    className="text-xs uppercase tracking-[0.28em] text-ls-inkSoft font-sans mb-6"
                    data-testid="section-eyebrow"
                >
                    <span className="inline-block w-8 h-px bg-ls-ink align-middle mr-3" />
                    {eyebrow}
                </motion.p>
            )}
            <motion.h2
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, delay: 0.1 }}
                className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight text-ls-ink leading-[1.05] text-balance"
                data-testid="section-title"
            >
                {title}
            </motion.h2>
            {intro && (
                <motion.p
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.8, delay: 0.25 }}
                    className="mt-6 text-base md:text-lg text-ls-inkSoft font-sans leading-relaxed max-w-2xl"
                >
                    {intro}
                </motion.p>
            )}
        </div>
    );
};

export default SectionHeader;
